import { SuccessModal } from "@components/SuccessModal/SuccessModal";
import { useAuth } from "@hooks/useAuth";
import { useLocalStorage } from "@hooks/useLocalStorage";
import { Icon } from "@iconify/react";
import { Button, Checkbox, Col, Form, message, Row, Select, Space, Typography } from "antd";
import { ErrorMessage, Field, FieldProps, Formik } from "formik";
import { isBoolean } from "lodash";
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { ContentWrapper } from "~/Components";
import { post } from "~/Services";
import styles from "../../../Dedicated/UserManagement/Dedicated.module.scss";

interface FormItems {
  division: string;
  LOA_Creator: boolean;
  LOA_Reviewer: boolean;
  Contract_Creator: boolean;
  Contract_Reviewer: boolean;
  Management_Dashboard: boolean;
  PCD_Admin: boolean;
  ERAMAN_CREATOR: boolean;
  MAGP_CREATOR: boolean;
  APSS_CREATOR: boolean;
  EMPLOYEEAPP_CREATOR: boolean;
  PASSENGER_CREATOR: boolean;
  PASSENGER_ECMS_CREATOR: boolean;
  MAHB_CORPORATE_CREATOR: boolean;
  ERAMAN_REVIEWER: boolean;
  MAGP_REVIEWER: boolean;
  APSS_REVIEWER: boolean;
  EMPLOYEEAPP_REVIEWER: boolean;
  PASSENGER_REVIEWER: boolean;
  PASSENGER_ECMS_REVIEWER: boolean;
  MAHB_CORPORATE_REVIEWER: boolean;
}

const defaultValue: any = {
  division: "",
  LOA_Creator: false,
  LOA_Reviewer: false,
  Contract_Creator: false,
  Contract_Reviewer: false,
  Management_Dashboard: false,
  PCD_Admin: false,
  ERAMAN_CREATOR: false,
  MAGB_CREATOR: false,
  APSS_CREATOR: false,
  EMPLOYEEAPP_CREATOR: false,
  PASSENGER_CREATOR: false,
  PASSENGER_ECMS_CREATOR: false,
  MAHB_CORPORATE_CREATOR: false,
  ERAMAN_REVIEWER: false,
  MAGB_REVIEWER: false,
  APSS_REVIEWER: false,
  EMPLOYEEAPP_REVIEWER: false,
  PASSENGER_REVIEWER: false,
  PASSENGER_ECMS_REVIEWER: false,
  MAHB_CORPORATE_REVIEWER: false,
} as any;

const EqualCol = ({ children }: { children: ReactNode }) => (
  <Col
    xs={24}
    md={12}
  >
    {children}
  </Col>
);

export const RequestAccess = () => {
  const [loading, setLoading] = useState(false);
  const [successLoader, setSuccessLoader] = useState(false);
  const [defUser, setDefUser] = useLocalStorage("user", null);

  const { user } = useAuth();

  const navigate = useNavigate();

  const validationSchema1 = yup.object().shape({
    division: yup.string().strict(true).required("division is required"),
  });

  const onSubmit = async (values: any) => {
    const roles = [];
    for (const [key, value] of Object.entries(values)) {
      if (value && isBoolean(value)) {
        roles.push(key);
      }
    }
    if (roles.length == 0) {
      message.info("Atleast a single role must be requested for onboarding request");
      return;
    }
    const payload = {
      division: values.division,
      requestRoles: roles,
    };
    setLoading(true);
    post(`user/onboarding/request`, payload)
      .then((res) => {
        setDefUser({ ...defUser, isRequestedStatus: true, status: "pending" });
        setSuccessLoader(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <ContentWrapper
      customTitle={
        <Space align="start">
          <Icon
            onClick={() => navigate(-1)}
            icon="akar-icons:arrow-left"
            style={{
              fontSize: "1.8rem",
              cursor: "pointer",
              color: styles.primary,
              marginRight: styles.whitespace1,
            }}
          />
          <span>
            <Typography.Title
              level={5}
              style={{ margin: 0 }}
            >
              Request Access
            </Typography.Title>
          </span>
        </Space>
      }
    >
      <Formik
        initialValues={defaultValue}
        onSubmit={(values) => onSubmit(values)}
        validationSchema={validationSchema1}
      >
        {(props) => {
          return (
            <Form
              layout="vertical"
              onFinish={props.handleSubmit}
            >
              <Row style={{ marginTop: 16, display: "block", width: "100%" }}>
                <Col
                  xs={24}
                  md={16}
                >
                  {
                    <>
                      <Row gutter={16}>
                        <Col md={24}>
                          <Typography.Title
                            level={5}
                            style={{ marginBottom: 10 }}
                          >
                            Select Division Which you want to request for Access
                          </Typography.Title>
                        </Col>
                        <Col
                          md={8}
                          sm={24}
                        >
                          <Form.Item label={"Select Division"}>
                            <Field name={`division`}>
                              {({ field }: FieldProps) => (
                                <Select
                                  showSearch
                                  value={field.value}
                                  filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                  onChange={(e) => {
                                    props.setFieldValue("division", e);
                                  }}
                                  onBlur={() => props.setFieldTouched("division", true)}
                                  status={(props.touched.division && props.errors.division && "error") || ""}
                                >
                                  <Select.Option
                                    value={"Dedicated"}
                                    key={"Dedicated"}
                                  >
                                    {"Dedicated"}
                                  </Select.Option>
                                  <Select.Option
                                    value={"Centralized"}
                                    key={"Centralized"}
                                  >
                                    {"Centralized"}
                                  </Select.Option>
                                </Select>
                              )}
                            </Field>
                            <Typography.Text type="danger">
                              <ErrorMessage name={`division`} />
                            </Typography.Text>
                          </Form.Item>
                        </Col>
                      </Row>
                      {props.values.division == "Dedicated" && (
                        <Row gutter={16}>
                          <Col md={24}>
                            <Typography.Title
                              level={5}
                              style={{ marginBottom: 10 }}
                            >
                              Choose the access you want
                            </Typography.Title>
                          </Col>
                          {}
                        </Row>
                      )}
                      {props.values.division == "Centralized" && (
                        <Row gutter={16}>
                          <Col md={24}>
                            <Typography.Title
                              level={5}
                              style={{ marginBottom: 10 }}
                            >
                              Choose the access you want
                            </Typography.Title>
                          </Col>
                          {
                            <>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`ERAMAN_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>Eraman Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`MAGB_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>MAHB Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`APSS_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>APSS Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`EMPLOYEEAPP_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>Employee App Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  {/* <Field name={`MAHBCOMM_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>MAHBCOMM Creator</Checkbox>
                                      </>
                                    )}
                                  </Field> */}
                                  <Field name={`PASSENGER_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>Passenger Butterfly Effect Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`PASSENGER_ECMS_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>Passenger ECMS Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`MAHB_CORPORATE_CREATOR`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>MAHBCORP Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`ERAMAN_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>MAGB Creator</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`MAGB_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>MAGB Reviewer</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`APSS_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>APSS Reviewer</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`EMPLOYEEAPP_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>Employee APP Reviewer</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  {/* <Field name={`MAHBCOMM_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>MAHBCOMM Reviewer</Checkbox>
                                      </>
                                    )}
                                  </Field> */}
                                  <Field name={`PASSENGER_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>Passenger Butterfly Effect Reviewer</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`PASSENGER_ECMS_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>Passenger ECMS Reviewer</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                              <Col md={24}>
                                <Form.Item>
                                  <Field name={`MAHB_CORPORATE_REVIEWER`}>
                                    {({ field }: FieldProps) => (
                                      <>
                                        <Checkbox {...field}>MAHBCORP Reviewer</Checkbox>
                                      </>
                                    )}
                                  </Field>
                                </Form.Item>
                              </Col>
                            </>
                          }
                        </Row>
                      )}
                    </>
                  }
                </Col>
              </Row>
              <Row>
                <Col
                  xs={16}
                  md={8}
                  sm={24}
                  style={{ textAlign: "right" }}
                >
                  <Space>
                    <Button
                      htmlType="submit"
                      type="primary"
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
      <SuccessModal
        redirect={"/ecms/welcome-page"}
        title={"Successfully Requested Access"}
        message={"You have Successfully Requested Access for CLM"}
        type={"success"}
        buttonText={"Go Back"}
        open={successLoader}
        setOpen={setSuccessLoader}
      />
    </ContentWrapper>
  );
};
